import type { BatchSchedule } from 'lib-shared-types-api';

import { FlowNodeTypes } from '../components/types';
import { Action } from '../hooks/useScheduleFetch';

export function getNodeSchedulesIds(
  actions?: Action[] | null,
): BatchSchedule['id'][] {
  return actions
    ? actions.reduce<BatchSchedule['id'][]>(
        (acc, { nodeType, payload }) =>
          nodeType === FlowNodeTypes.BUSINESS_HOURS &&
          !acc.includes(payload.scheduleId)
            ? [...acc, payload.scheduleId]
            : acc,
        [],
      )
    : [];
}
